import React, { useState, useEffect, useCallback } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { FiHeart, FiShoppingBag, FiUser, FiMenu, FiX } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import { useCart } from '../context/CartContext';
import api from '../services/api';

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [megaOpen, setMegaOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const { user, logout } = useAuth();
  const { cartCount } = useCart();
  const [wishCount, setWishCount] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('catalog/categories/').then(r => {
      setCategories(r.data.results || r.data);
    }).catch(() => {});
  }, []);

  const fetchWishCount = useCallback(() => {
    if (!user) { setWishCount(0); return; }
    api.get('auth/wishlist/').then(r => {
      const data = r.data.results || r.data;
      setWishCount(Array.isArray(data) ? data.length : (r.data.count || 0));
    }).catch(() => {});
  }, [user]);

  useEffect(() => { fetchWishCount(); }, [fetchWishCount]);
  useEffect(() => {
    const handler = () => fetchWishCount();
    window.addEventListener('focus', handler);
    window.addEventListener('wishlist-updated', handler);
    return () => { window.removeEventListener('focus', handler); window.removeEventListener('wishlist-updated', handler); };
  }, [fetchWishCount]);

  const handleLogout = () => { logout(); setDropdownOpen(false); setMenuOpen(false); navigate('/'); };
  const close = () => { setMenuOpen(false); setDropdownOpen(false); };

  const navLinks = [
    { to: '/', label: 'Home' },
    { to: '/men', label: 'Men' },
    { to: '/women', label: 'Women' },
  ];

  return (
    <>
      <nav className="navbar">
        <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          {menuOpen ? <FiX size={22} /> : <FiMenu size={22} />}
        </button>

        <Link to="/" className="logo" onClick={close}>HEANDSHESTYLE</Link>

        <div className="nav-links-desktop">
          {navLinks.map(l => <NavLink key={l.to} to={l.to} className={({isActive}) => isActive ? 'active' : ''} end={l.to === '/'}>{l.label}</NavLink>)}
          <div className="mega-menu-trigger" onMouseEnter={() => setMegaOpen(true)} onMouseLeave={() => setMegaOpen(false)}>
            <NavLink to="/shop" className={({isActive}) => isActive ? 'active' : ''}>Shop</NavLink>
            {megaOpen && categories.length > 0 && (
              <div className="mega-menu">
                {categories.filter(c => !c.parent).map(cat => (
                  <div key={cat.id} className="mega-menu-col">
                    <Link to={`/shop?category=${cat.slug}`} className="mega-menu-title" onClick={() => setMegaOpen(false)}>{cat.name}</Link>
                    {(cat.children || []).map(child => (
                      <Link key={child.id} to={`/shop?category=${child.slug}`} className="mega-menu-item" onClick={() => setMegaOpen(false)}>{child.name}</Link>
                    ))}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="nav-icons">
          <Link to="/wishlist" aria-label="Wishlist" style={{ position: 'relative' }}>
            <FiHeart size={18} />
            {wishCount > 0 && <span className="cart-badge">{wishCount}</span>}
          </Link>
          <Link to="/cart" aria-label="Cart" style={{ position: 'relative' }}>
            <FiShoppingBag size={18} />
            {cartCount > 0 && <span className="cart-badge">{cartCount}</span>}
          </Link>
          <div className="user-menu">
            {user ? (
              <div className="avatar" onClick={() => setDropdownOpen(!dropdownOpen)}>
                {(user.first_name?.[0] || user.username?.[0] || '').toUpperCase()}
              </div>
            ) : (
              <FiUser size={18} style={{ cursor: 'pointer' }} onClick={() => setDropdownOpen(!dropdownOpen)} />
            )}
            {dropdownOpen && (
              <>
                <div className="dropdown-overlay" onClick={() => setDropdownOpen(false)} />
                <div className="dropdown">
                  {user ? (
                    <>
                      <div className="dropdown-greeting">Hi, {user.first_name || user.username}</div>
                      <Link to="/profile" onClick={close}>Profile</Link>
                      <Link to="/orders" onClick={close}>My Orders</Link>
                      <Link to="/wishlist" onClick={close}>Wishlist</Link>
                      <button onClick={handleLogout}>Logout</button>
                    </>
                  ) : (
                    <>
                      <Link to="/login" onClick={close}>Login</Link>
                      <Link to="/register" onClick={close}>Register</Link>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
        </div>
      </nav>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="mobile-menu">
          {navLinks.map(l => <Link key={l.to} to={l.to} onClick={close}>{l.label}</Link>)}
          <Link to="/shop" onClick={close}>All Products</Link>
          {categories.filter(c => !c.parent).map(cat => (
            <Link key={cat.id} to={`/shop?category=${cat.slug}`} onClick={close} style={{ paddingLeft: 16 }}>{cat.name}</Link>
          ))}
          {user && <Link to="/profile" onClick={close}>My Account</Link>}
          {!user && <Link to="/login" onClick={close}>Login</Link>}
        </div>
      )}
    </>
  );
}
